import { Entity } from '@app/core';
import { INews } from '@games/interfaces';

export class News extends Entity<INews> {
  constructor(props: INews) {
    super(props);
  }

  get id(): number {
    return this.props.id;
  }

  get news(): string {
    return this.props.news;
  }

  get period(): number {
    return this.props.period;
  }

  get filed(): Date | null {
    return this.props.filed && new Date(this.props.filed);
  }

  getFiled(locale: string | string[]) {
    return (
      this.props.filed &&
      new Date(this.props.filed).toLocaleString(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    );
  }
}
